










































import Vue from 'vue'
import { User } from '@/modules/core/models'

export default Vue.extend({
  props: {
    user: User
  },
  data: () => ({}),
  computed: {
    get_workHours: function () {
      switch (this.user.hours_of_work) {
        case 40: {
          return 'A tiempo completo'
          break
        }
        case 20: {
          return 'Media jornada'
          break
        }
        default: {
          return this.user.hours_of_work
          break
        }
      }
    },
    get_avatar_image: function () {
      const background_colors = ['F9A825', '224177', '00838F', '9C27B0']

      let random_color = background_colors[Math.floor(Math.random() * 3) ]

      return `https://eu.ui-avatars.com/api/?name=${this.user.name}+${this.user.surname}&rounded=true&size=128&background=${random_color}&color=fff`
    }
  }
})
